<template>
  <div class="cart-item">
    <div class="p-2 flex items-center justify-between bg-secondary  text-white">
      <div>{{ data.game.name }}</div>
      <QBtn
        icon="close"
        flat
        dense
        round
        @click="cartStore.selectMiniGameItem(data)"
      />
    </div>
    <div class="flex-grow px-2 py-3 grid grid-cols-12 bg-gradient-to-b light:(from-light-1 to-light-3) dark:(from-dark-1 to-dark-3)">
      <div class="col-span-9 flex flex-col justify-center gap-2">
        <div class="w-full flex flex-nowrap items-center gap-2 ">
          <div class="truncate">
            {{ data.market.name }}
          </div>
        </div>
        <div class="w-full flex flex-nowrap items-center gap-2">
          <div class="max-w-1/2 truncate">
            {{ data.odds.name }}
          </div>
        </div>
      </div>
      <div class="col-span-3 odds-value">
        {{ data.odds.value }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCartStore } from '@/stores/cart.js'

defineProps({
  data: {
    type: Object,
    default: () => ({})
  }
})

const cartStore = useCartStore()
</script>
